
import { Link } from 'react-router-dom';
import { Gamepad2 } from 'lucide-react';
import { useWebsiteSettings } from '@/hooks/useWebsiteSettings';

export const Logo = () => {
  const { settings, isLoading } = useWebsiteSettings();
  
  // Don't render anything until settings are loaded to prevent flash
  if (isLoading) {
    return (
      <div className="flex items-center space-x-2 sm:space-x-3">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-200 rounded-xl animate-pulse"></div>
        <div className="hidden sm:block w-24 h-6 bg-gray-200 rounded animate-pulse"></div>
      </div>
    );
  }
  
  const siteName = settings.site_name || 'TerraGamers';
  const logoUrl = settings.logo_url;
  
  // Get logo sizing settings with defaults
  const logoMobileHeight = settings.logo_mobile_height || 48;
  const logoDesktopHeight = settings.logo_desktop_height || 64;
  const logoMaxWidth = settings.logo_max_width || 200;
  const logoMaxWidthDesktop = settings.logo_max_width_desktop || 280;

  // Create dynamic styles
  const logoContainerStyle = {
    height: `${logoMobileHeight}px`,
    '--desktop-height': `${logoDesktopHeight}px`,
  } as React.CSSProperties & { '--desktop-height': string };

  const logoImageStyle = {
    maxWidth: `${logoMaxWidth}px`,
    '--desktop-max-width': `${logoMaxWidthDesktop}px`,
  } as React.CSSProperties & { '--desktop-max-width': string };

  // Check if we should show custom logo - more strict validation
  const showCustomLogo = Boolean(
    logoUrl && 
    logoUrl.trim() !== '' && 
    logoUrl !== 'undefined' && 
    logoUrl !== 'null' &&
    logoUrl.startsWith('http')
  );

  return (
    <Link to="/" className="flex items-center space-x-2 sm:space-x-3 group">
      {showCustomLogo ? (
        <div 
          className="flex-shrink-0 transform group-hover:scale-105 transition-transform duration-300 sm:h-[var(--desktop-height)]"
          style={logoContainerStyle}
        >
          <img 
            src={logoUrl} 
            alt={siteName}
            className="h-full w-auto object-contain sm:max-w-[var(--desktop-max-width)]"
            style={logoImageStyle}
            loading="eager"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      ) : (
        <>
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
            <Gamepad2 className="w-4 h-4 sm:w-6 sm:h-6 text-white" />
          </div>
          <span className="hidden sm:block text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent truncate max-w-[200px]">
            {siteName}
          </span>
          <span className="sm:hidden text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            {siteName.split(' ')[0]}
          </span>
        </>
      )}
    </Link>
  );
};
